import React, { useContext, lazy } from 'react'
import { ScreenContext } from 'components/Providers'

const Desktop = lazy(() => import('./DesktopTablet'))
const Mobile = lazy(() => import('./Mobile'))

const SocialProof: React.FC = () => {

  const { mobile } = useContext(ScreenContext)

  if (mobile) {
    return (
      <Mobile/>
    )
  } else {
    return (
      <Desktop/>
    )
  }
}

export default SocialProof